<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color" [class.d-none]="route.children.length !== 0">
    <div class="row row-cols-1 row-cols-sm-2 py-4">
      <div class="col d-flex align-items-center">
        <h1 class="fs-4 fw-bold text-primary-color my-0">Relatório de E-mails Cadastrados</h1>
      </div>
    </div>

    <nz-divider class="m-0 p-0 mt-2 mb-4"></nz-divider>
    <div class="col-12">

      <form [formGroup]="relatorioEmailForm" (ngSubmit)="pesquisar()">
        <div class="row row-cols-1 row-cols-sm-3 g-4">
          <div class="col form-group">
            <label for="email" class="form-label">Email</label>
            <input nz-input placeholder="Email" [nzSize]="size" name="email" formControlName="email" />
            <div *ngIf="relatorioEmailForm.controls['email'].touched">
              <span *ngIf="relatorioEmailForm.controls['email'].errors?.['required']">O email é obrigatório.</span>
            </div>
          </div>
        </div>

        <div class="form-group d-flex justify-content-end ml-3">
          <button nz-button type="submit" nzType="primary" [nzSize]="size" class="rounded-pill mt-4 me-3"
            [disabled]="!relatorioEmailForm.valid" aria-label="Pesquisar">
            Pesquisar
          </button>
          <!-- <button nz-button type="button" nzType="default" [nzSize]="size" class="rounded-pill mt-4 me-3"
            (click)="resetForm()">
            Limpar
          </button> -->
        </div>
      </form>

    </div>

    <div class="col-12">
      <nz-divider class="m-0 p-0 mt-4 mb-4"></nz-divider>
      <div class="d-flex flex-column page-content border border-radius w-100">
        <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
          (nzQueryParams)="sort($event)" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate">
          <thead>
            <tr>
              <th nzColumnKey="tela" nzShowSort [nzSortFn]="true">
                Tela
              </th>
              <th nzColumnKey="email" nzShowSort [nzSortFn]="true">
                E-mail
              </th>
              <th nzColumnKey="tipoContato" nzShowSort [nzSortFn]="true">
                Tipo de Contato
              </th>
              <th nzColumnKey="creationDate" nzShowSort [nzSortFn]="false">
                Atalho
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="paginator?.paginaAtual">
              <tr *ngFor="let item of dataSet">
                <td>{{ item?.tela }}</td>
                <td>{{ item?.email }}</td>
                <td>{{ item?.tipoContato }}</td>
                <td>
                  <a nz-button nzType="link" (click)="navegarParaDetalhe(item)">
                    <span nz-icon nzType="link" nzTheme="outline"></span>
                  </a>
                </td>

              </tr>
            </ng-container>
          </tbody>

        </nz-table>
        <ng-template #footerTemplate>
          <section class="d-flex justify-content-end w-100">
            <app-pagination [itemPorPagina]="20"></app-pagination>
          </section>
        </ng-template>
        <ng-template #semDadosTemplate>
          <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
            <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
